// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Avatar = require("./Avatar.bs.js");
let ButtonsV5 = require("./ButtonsV5.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let AgentInfo_agent_graphql = require("../../../__generated__/AgentInfo_agent_graphql.bs.js");
let TerminatedAgentIconOverlay = require("./TerminatedAgentIconOverlay.bs.js");

let convertFragment = AgentInfo_agent_graphql.Internal.convertFragment;

function toStep(size) {
  if (size === "medium") {
    return 3;
  } else if (size === "small") {
    return 2;
  } else if (size === "xxSmall") {
    return 0;
  } else if (size === "xSmall") {
    return 1;
  } else {
    return 5;
  }
}

function wrapSelf(element) {
  return element;
}

function AgentInfo$Presentation(props) {
  let children = props.children;
  let __wrapAvatar = props.wrapAvatar;
  let __wrapName = props.wrapName;
  let brokerage = props.brokerage;
  let name = props.name;
  let __size = props.size;
  let onClick = props.onClick;
  let size = __size !== undefined ? __size : "small";
  let wrapName = __wrapName !== undefined ? __wrapName : wrapSelf;
  let wrapAvatar = __wrapAvatar !== undefined ? __wrapAvatar : wrapSelf;
  return JsxRuntime.jsxs("div", {
    children: [
      wrapAvatar(JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Avatar.make, {
          name: name,
          src: props.avatar,
          size: toStep(size),
          onClick: onClick
        }),
        className: size === "xxSmall" ? "mr-2 shrink-0" : "mr-[15px] shrink-0"
      })),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: wrapName(name),
            className: TailwindMerge.twMerge([
              size === "xxSmall" ? "font-normal leading-none text-zinc-800" : "font-semibold leading-none text-zinc-800",
              Stdlib_Option.isSome(onClick) ? "cursor-pointer" : "",
              size === "xSmall" || size === "xxSmall" || size === "small" || size === "medium" ? "text-base" : "text-lg"
            ]),
            onClick: onClick
          }),
          brokerage !== undefined ? JsxRuntime.jsx("div", {
              children: brokerage,
              className: size === "xxSmall" ? "mt-1 leading-none text-base font-normal text-zinc-500" : "mt-2 leading-none text-base font-normal text-zinc-500"
            }) : null,
          Stdlib_Option.getOr(children, null)
        ],
        className: "flex flex-col"
      })
    ],
    className: TailwindMerge.twMerge([
      "flex",
      Stdlib_Option.isSome(children) ? "items-start" : "items-center"
    ])
  });
}

let Presentation = {
  make: AgentInfo$Presentation
};

function AgentInfo$FromAgent(props) {
  let __size = props.size;
  let __ring = props.ring;
  let __linkToAgent = props.linkToAgent;
  let overrideBrokerage = props.overrideBrokerage;
  let linkToAgent = __linkToAgent !== undefined ? __linkToAgent : true;
  let ring = __ring !== undefined ? __ring : false;
  let size = __size !== undefined ? __size : "xSmall";
  let agent = RescriptRelay_Fragment.useFragment(AgentInfo_agent_graphql.node, convertFragment, props.agent);
  let brokerage;
  let displayName;
  let id;
  let profilePhoto;
  let id$1 = agent.id;
  let displayName$1 = agent.displayName;
  let brokerage$1 = agent.brokerage;
  let tmp = agent.membershipStatus;
  if (tmp === "ACTIVE" || tmp === "TERMINATED") {
    if (tmp !== "ACTIVE") {
      return JsxRuntime.jsx(TerminatedAgentIconOverlay.make, {
        size: size,
        children: JsxRuntime.jsx(AgentInfo$Presentation, {
          avatar: AvatarSrcUrl.place_holder,
          size: size,
          name: displayName$1,
          brokerage: "NO LONGER ON TAN"
        })
      });
    }
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  } else {
    brokerage = brokerage$1;
    displayName = displayName$1;
    id = id$1;
    profilePhoto = agent.profilePhoto;
  }
  let avatar = profilePhoto !== undefined ? (
      ring ? profilePhoto.urlWithRing : profilePhoto.url
    ) : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo$Presentation, {
    avatar: avatar,
    size: size,
    name: Stdlib_Option.getOr(props.overrideDisplayName, displayName),
    brokerage: overrideBrokerage !== undefined ? overrideBrokerage : brokerage,
    wrapName: name => {
      let content = JsxRuntime.jsx("div", {
        children: name,
        className: size === "xxSmall" ? "font-normal" : "font-medium"
      });
      if (linkToAgent) {
        return JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: `/agents/` + id,
          onClick: e => {
            e.stopPropagation();
          },
          children: content
        });
      } else {
        return content;
      }
    },
    children: Stdlib_Option.getOr(props.children, null)
  });
}

let FromAgent = {
  make: AgentInfo$FromAgent
};

function AgentInfo$FromAgentOpt(props) {
  let agent = props.agent;
  if (agent !== undefined) {
    return JsxRuntime.jsx(AgentInfo$FromAgent, {
      agent: Primitive_option.valFromOption(agent),
      size: props.size
    });
  } else {
    return null;
  }
}

let FromAgentOpt = {
  make: AgentInfo$FromAgentOpt
};

let make = AgentInfo$FromAgent;

exports.toStep = toStep;
exports.Presentation = Presentation;
exports.FromAgent = FromAgent;
exports.FromAgentOpt = FromAgentOpt;
exports.make = make;
/* Avatar Not a pure module */
